module.exports = require('../../es/string/starts-with');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/features/string/starts-with.js
// module id = 297
// module chunks = 0